import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { InteractionsPanel } from '@/components/interactions/interactions-panel'
import { interactionsShape } from '@/lib/interaction-search'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId/echanges')({
  validateSearch: (search: Record<string, unknown>) => readSearch(interactionsShape, search),
  component: ClientInteractionsPage,
})

function ClientInteractionsPage() {
  const client = useShellClient()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Frame>
      <InteractionsPanel
        clientId={client.id}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: (current) => ({ ...current, ...next }) })
        }}
      />
    </Frame>
  )
}
